var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.activeOfferComponent)?_c('div',{staticClass:"c-offer",class:[
    'l-flex',
    'l-flex--justify-start',
    'l-flex--column'
  ]},[_c(_vm.activeOfferComponent,_vm._b({tag:"component",staticClass:"c-offer__active",on:{"select":function($event){return _vm.$emit('select', $event)}}},'component',_vm.activeOfferProps,false))],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }